<mat-card class="match-card d-flex flex-row" [class.with-border]="borderStyle">
    <div class="match-card-header">
        <mat-card-title class="match-card-header-title">{{ title }}</mat-card-title>
        <mat-card-subtitle class="match-card-header-subtitle">{{ author }}</mat-card-subtitle>
    </div>
    <div class="match-card-content">
        <span class="match-card-content-number">
        {{ number }}
        </span>
    </div>
</mat-card>
